module.exports = require('./helpers/bundle-url').getBundleURL('lpdTb') + "logo-dark.eefe0b7f.svg";